/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupListItem
 */
export interface AgencyGroupListItem {
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupListItem
     */
    id?: string;
    /**
     * 
     * @type {object}
     * @memberof AgencyGroupListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AgencyGroupListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupListItem
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupListItem
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyGroupListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyGroupListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyGroupListItem
     */
    allowEdit?: boolean;
}

export function AgencyGroupListItemFromJSON(json: any): AgencyGroupListItem {
    return AgencyGroupListItemFromJSONTyped(json, false);
}

export function AgencyGroupListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AgencyGroupListItemToJSON(value?: AgencyGroupListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'label': value.label,
        'description': value.description,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


